<template>
  <v-container>
    <v-window v-model="step">
      <v-window-item>
        <div class="text-h4">Michigan 9-1-1 Fee Exemption Certificate</div>
        <v-text-field
          v-model="general.emergencytax_company_name"
          label="Company Name"
        ></v-text-field>
        <v-text-field
          v-model="general.emergencytax_accounts_exempt"
          label="Exempted Accounts"
        ></v-text-field>
        <AddressAutocomplete
          :value="emergencytaxAddress"
          @registerAddressChange="setAddress"
        />
      </v-window-item>
      <v-window-item>
        <div class="text-h4">Authorized Contact & Signature</div>
        <ESignature
          v-model="general.emergencytax_sig_name"
          :accepted.sync="general.emergencytax_certified"
          :preamble="signaturePreamble"
        >
          <Contact
            :d="contactData"
            :roles="['MI911 Fee Exemption Contact']"
            @assignContact="assignContact"
            contact-title
          />
        </ESignature>
      </v-window-item>
    </v-window>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import AddressAutocomplete from "@/components/formfields/AddressAutocomplete.vue";
import ESignature from "@/components/formfields/ESignature.vue";
import Contact from '@/components/formfields/Contact.vue';

export default {
  name: 'MI911',
  created() {
    const vm = this;
    vm.general = _.cloneDeep(vm.getQuoteInfo);
    if (!vm.general.emergencytax_company_name) {
      vm.general.emergencytax_company_name = vm.getQuoteFacts.company_name;
    }
    vm.hijackStepper(async (goRight) => {
      if ((vm.step === 0 && !goRight) || (vm.step === vm.maxStep && goRight)) {
        vm.unHijackStepper();
        vm.nextSubTab(goRight);
      }
      vm.step += (goRight ? 1 : -1);
    });
  },
  methods: {
    ...mapActions(['syncFormData', 'nextSubTab', 'hijackStepper', 'unHijackStepper']),
    sync() {
      const vm = this;
      vm.syncFormData({
        mainKey: 'general',
        data: _.cloneDeep(vm.general),
      });
    },
    setAddress(newAddress) {
      this.$set(this.general, 'emergencytax_address', newAddress.streetAddress);
      this.$set(this.general, 'emergencytax_suite', newAddress.suite);
      this.$set(this.general, 'emergencytax_city', newAddress.city);
      this.$set(this.general, 'emergencytax_state', newAddress.state);
      this.$set(this.general, 'emergencytax_zip', newAddress.zip);
    },
    assignContact(e) {
      this.$set(this.general, 'emergencytax_contact_name', e.fullname);
      this.$set(this.general, 'emergencytax_email', e.email);
      this.$set(this.general, 'emergencytax_contact_phone', e.phone);
      this.$set(this.general, 'emergencytax_title', e.title);
    },
  },
  computed: {
    ...mapGetters(['getQuoteInfo', 'getQuoteFacts']),
    emergencytaxAddress() {
      const address = {};
      if (this.general.emergencytax_address != null) {
        address.streetAddress = this.general.emergencytax_address;
        address.suite = this.general.emergencytax_suite;
        address.city = this.general.emergencytax_city;
        address.state = this.general.emergencytax_state;
        address.zip = this.general.emergencytax_zip;
      }
      return address;
    },
    maxStep() {
      return 1;
    },
    contactData() {
      return {
        fullname: this.general.emergencytax_contact_name,
      };
    },
    signaturePreamble() {
      return `
The undersigned represents he/she is authorized to execute this certificate on behalf of <b>${this.general.emergencytax_company_name}</b>.("Company") and hereby claims exemption from 123.Net, Inc.'s assessment of Michigan 9-1-1 Fees (hereafter the "Fee") on Company's purchases from 123.Net, Inc. 24700 Northwestern Hwy. Fl. 7 Southfield, MI 48075("123.Net").

I certify under penalty of perjury that the Company is utilizing 9-1-1 services in the State of Michigan. I also certify that the Company collects and remits payment to the appropriate 9-1-1 public safety answering points as per guidelines of the Michigan Public Service Commission and the State 9-1-1 Committee. I further certify that if any telecommunications service so purchased without the Fee is used or consumed by Company as to make it subject to the Fee, Company will pay the Fee directly to the proper authority when state law so provides, or will inform 123.Net so that the Fee will be added to Company's future 123.Net billings. This certificate will be considered a part of each prior order and future order which Company may here after give to 123.Net and shall be valid until cancelled by Company in writing or revoked by the State.

I declare under the penalties of perjury that this certificate has been examined by me and to the best of my knowledge and belief all statements contained herein are true, correct and accurate.
      `;
    },
  },
  data() {
    return {
      general: {},
      step: 0,
    };
  },
  watch: {
    general: {
      handler() {
        this.sync();
      },
      deep: true,
    },
  },
  components: {
    AddressAutocomplete,
    ESignature,
    Contact,
  },
};
</script>
